import React from "react";
import cx from "classnames";

import styles from "./index.module.scss";

interface SvgProps {
  icon: string;
  style?: any;
  className?: string;
}

const XtSvg: React.FC<SvgProps> = ({ className, icon, style }) => {
  return (
    <svg className={cx(styles.main, className)} style={style}>
      <use href={"#" + icon}></use>
    </svg>
  );
};

export default XtSvg;
